import { waitForAsync } from '@angular/core/testing';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forEach } from 'jszip';
import { AdminAction } from 'src/app/models/adminaction.model';
import { SchoolModuleBatch } from 'src/app/models/module/moduledetails';
import { FeatureGroups } from 'src/app/models/school/schooladminitem.model';
import { AssessmentmanagerService } from 'src/app/services/assessments/assessmentmanager.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { UtilService } from 'src/app/services/util.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';

@Component({
  selector: 'app-view-course-assessments',
  templateUrl: './view-course-assessments.component.html',
  styleUrls: ['./view-course-assessments.component.css'],
})
export class ViewCourseAssessmentsComponent implements OnInit {
  moduleId: any;
  FILTER_ALL: string = 'all';
  FILTER_TIMED: string = 'timed_val';
  filter: string = this.FILTER_ALL;
  assessmentList: any[] = [];
  filteredAssessmentList: any[] = [];
  timedCount: number = 0;
  crumbitem: any;
  isadmin: boolean;
  courseFilterActions: AdminAction[] = [];
  isBatched = true;
  moduleBatches: SchoolModuleBatch[] = [];

  @ViewChild('actionslink') actionsLink: ElementRef;
  @ViewChild('actionslinkBatch') actionslinkBatch: ElementRef;
  FilterByLessonText: string = 'All Lessons';
  FilterByBatchText=0;
  constructor(
    public headerinfo: ComponentheaderService,
    private router: Router,
    private activatedroute: ActivatedRoute,
    private assessmentManager: AssessmentmanagerService,
    public moduleservice: ModulemanagementService,
    private util: UtilService
  ) {}

  async ngOnInit() {
    this.headerinfo.pageLoadingStarted(this);
    this.moduleId = this.activatedroute.snapshot.queryParams.moduleid;
    let defaultCourseAction = new AdminAction();
    defaultCourseAction.displaytext = 'All Lessons';
    defaultCourseAction.callback = (title: string) =>
      this.filterByLesson(title);
    this.courseFilterActions.push(defaultCourseAction);
    this.headerinfo.setHeaderDisplay(
      `All Assessments `,
      [
        {
          displaytext: 'School',
          route: `/user/schoolhome`,
        },
        {
          displaytext: 'Course',
          route: `/user/moduledetails`,
          params: { moduleID: this.moduleId },
        },
        {
          displaytext: `All Assessments`,
          route: `/user/allassessments`,
          params: { moduleid: this.moduleId },
        },
      ],
      []
    );

    if(!await this.util.hasFeature(FeatureGroups.ASSESSMENTS)){
      this.util.notifyFeatureNotAvailable(FeatureGroups.ASSESSMENTS);
      this.headerinfo.pageLoadingDone(this);
      this.router.navigate(['/user/moduledetails'], { queryParams: { moduleID: this.moduleId }});
      return;
    }

    this.moduleBatches = await this.moduleservice
        .getModuleBatches(this.moduleId)
        .toPromise();
    this.isBatched = this.moduleBatches.length > 0;
    this.assessmentManager.getCourseAssessments(this.moduleId, 0).then(
      async (response:any )=>{        
        if (response.isadmin)
        {          
          this.assessmentList = response.data;
          this.timedCount = this.assessmentList.filter((a) => a.istimed).length;
          console.log(this.timedCount);
          this.assessmentList.forEach((e) => {
            var obj = new AdminAction();
            obj.displaytext = e.coursetitle;
            obj.callback = (title: string) => this.filterByLesson(title);
            if (
              !this.courseFilterActions.find(
                (a) => a.displaytext == e.coursetitle
              )
            )
              this.courseFilterActions.push(obj);
          });
          this.filteredAssessmentList = this.assessmentList;
          this.isadmin = response.isadmin;
          this.crumbitem = response.breadcrumb;
          this.FilterByBatchText = this.moduleBatches.find(
            (x) => x.id == response.batch
          ).id;
          this.headerinfo.setHeaderDisplay(
            'All Assessments',
            [
              {
                displaytext: this.crumbitem.schoolName,
                route: `/user/schoolhome`,
              },
              {
                displaytext: this.crumbitem.moduleName,
                route: `/user/moduledetails`,
                params: { moduleID: this.moduleId },
              },
              {
                displaytext: `All Assessments`,
                route: `/user/allassessments`,
                params: { moduleid: this.moduleId },
              },
            ],
            []
          );
        }
      });

    this.headerinfo.pageLoadingDone(this);
  }

  viewfilter(filter: string, event) {
    this.filter = filter;
    this.filteredAssessmentList = [];
    let assessmentType: string;

    setTimeout(() => {
      switch (this.filter) {
        case this.FILTER_TIMED:
          assessmentType = 'istimed';
          break;
        default:
          this.filteredAssessmentList = this.assessmentList;
          return;
      }

      this.filteredAssessmentList = this.assessmentList.filter(
        (assessment) => assessment[assessmentType] === true
      );
    }, 0);
  }

  filterByLesson(title: string) {
    let assessmentType: string;
    switch (this.filter) {
      case this.FILTER_TIMED:
        this.filteredAssessmentList = this.filteredAssessmentList.filter(
          (a) => a['coursetitle'] == title && a['istimed'] === true
        );
        break;
      default:
        this.filteredAssessmentList = this.assessmentList;
        break;
    }

    if (title == 'All Lessons' && this.filter !== this.FILTER_TIMED) {
      this.filteredAssessmentList = this.assessmentList;
    } else if (this.filter === this.FILTER_TIMED && title == 'All Lessons') {
      this.filteredAssessmentList = this.assessmentList.filter(
        (a) => a['istimed'] === true
      );
    } else if (this.filter === this.FILTER_TIMED && title != 'All Lessons') {
      this.filteredAssessmentList = this.assessmentList.filter(
        (a) => a['coursetitle'] == title && a['istimed'] === true
      );
    } else {
      this.filteredAssessmentList = this.filteredAssessmentList.filter(
        (a) => a['coursetitle'] == title
      );
    }
    this.FilterByLessonText = title;
  }

  openAssessment(id: number, classid: string, batchid: number) {
    this.router.navigate(['/user/assessmentdetails'], {
      queryParams: {
        aid: id,
        classid: classid,
        batchid: batchid,
        target: this.assessmentManager.bufferRoute.Details,
      },
    });
  }

  batchActionsDropdownClicked() {
    setTimeout(
      (() => {
        if (
          this.actionslinkBatch.nativeElement.getAttribute('aria-expanded') ==
          'true'
        ) {
          $(this.actionslinkBatch.nativeElement.querySelector('i')).addClass(
            'fa-caret-up'
          );
          $(this.actionslinkBatch.nativeElement.querySelector('i')).removeClass(
            'fa-caret-down'
          );
        } else {
          $(this.actionslinkBatch.nativeElement.querySelector('i')).addClass(
            'fa-caret-down'
          );
          $(this.actionslinkBatch.nativeElement.querySelector('i')).removeClass(
            'fa-caret-up'
          );
        }
      }).bind(this),
      1
    );
  }
  async sortByBatch(batchid: number) {
    this.assessmentManager
      .getCourseAssessments(this.moduleId, batchid)
      .then((response: any) => {
        if (response.isadmin) {
          this.assessmentList = response.data;
          this.timedCount = this.assessmentList.filter((a) => a.istimed).length;
          this.assessmentList.forEach((e) => {
            var obj = new AdminAction();
            obj.displaytext = e.coursetitle;
            obj.callback = (title: string) => this.filterByLesson(title);
            if (
              !this.courseFilterActions.find(
                (a) => a.displaytext == e.coursetitle
              )
            )
              this.courseFilterActions.push(obj);
          });
          this.filteredAssessmentList = this.assessmentList;
          this.filterByLesson(this.FilterByLessonText);
        }
      });
  }
}
